import { Stack, Typography } from '@mui/material';
import { Sidebar, Snackbar } from 'app/components';
import { useEnv } from 'app/services';
import React from 'react';
const ContentLayout = ({ children }) => {
    const { MODE: mode } = useEnv();
    return (React.createElement(Stack, { direction: 'column', sx: { height: '100%' } },
        React.createElement(Stack, { direction: 'row', sx: {
                height: '100%',
                paddingBottom: mode === 'secondary' ? '30px' : 0,
                position: 'relative',
            } },
            React.createElement(Sidebar, null),
            React.createElement(Stack, { direction: 'column', sx: {
                    flex: '1',
                    height: '100%',
                } },
                React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: {
                        position: 'relative',
                        flex: '1',
                        overflow: 'hidden',
                    } }, children)),
            React.createElement(Snackbar, null)),
        mode === 'secondary' && (React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '100%',
                height: '30px',
                zIndex: 9999,
                padding: theme.spacing(0, 2),
                bgcolor: theme.palette.warning.main,
            }) },
            React.createElement(Typography, { variant: 'body2' }, "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0432 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435, \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u044B \u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B.")))));
};
export default ContentLayout;
